export default "__VITE_PUBLIC_ASSET__361fca9f__"